var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-b-5" },
    [
      _c(
        "v-table",
        {
          staticClass: "table_beauty",
          attrs: {
            data: _vm.tcpaHistoryData,
            "current-page": _vm.currentPage,
            "page-size": 10,
            "hide-sort-icons": true
          },
          on: {
            "update:currentPage": function($event) {
              _vm.currentPage = $event
            },
            "update:current-page": function($event) {
              _vm.currentPage = $event
            },
            totalPagesChanged: function($event) {
              _vm.totalPages = $event
            }
          },
          scopedSlots: _vm._u([
            {
              key: "body",
              fn: function({ displayData }) {
                return _c(
                  "tbody",
                  {},
                  _vm._l(displayData, function(row) {
                    return _c("tr", { key: row.id }, [
                      _c("td", [
                        _vm._v(_vm._s(_vm.getFormattedDate(row.time)))
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n          " +
                            _vm._s(row.name ? row.name : "API") +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n          " +
                            _vm._s(row.numbersChecked) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n          " +
                            _vm._s(row.numbersScrubed) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v("$" + _vm._s(row.cost))])
                    ])
                  }),
                  0
                )
              }
            }
          ])
        },
        [
          _c("thead", { attrs: { slot: "head" }, slot: "head" }, [
            _c(
              "tr",
              [
                _c(
                  "v-th",
                  {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "TCPA_SHIELD_HISTORY_TABLE_DATE",
                        expression: "'TCPA_SHIELD_HISTORY_TABLE_DATE'"
                      }
                    ],
                    attrs: { "sort-key": "time", "default-sort": "asc" }
                  },
                  [_vm._v("\n          Date\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "v-th",
                  {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "TCPA_SHIELD_HISTORY_TABLE_ORIGIN",
                        expression: "'TCPA_SHIELD_HISTORY_TABLE_ORIGIN'"
                      }
                    ],
                    attrs: { "sort-key": "name" }
                  },
                  [_vm._v("\n          Origin\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "v-th",
                  {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "TCPA_SHIELD_HISTORY_TABLE_CHECKED",
                        expression: "'TCPA_SHIELD_HISTORY_TABLE_CHECKED'"
                      }
                    ],
                    attrs: { "sort-key": "numbersChecked" }
                  },
                  [_vm._v("\n          Numbers Checked\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "v-th",
                  {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "TCPA_SHIELD_HISTORY_TABLE_SCRUBBED",
                        expression: "'TCPA_SHIELD_HISTORY_TABLE_SCRUBBED'"
                      }
                    ],
                    attrs: { "sort-key": "numbersScrubed" }
                  },
                  [_vm._v("\n          Numbers Scrubed\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "v-th",
                  {
                    directives: [
                      {
                        name: "t",
                        rawName: "v-t",
                        value: "TCPA_SHIELD_HISTORY_TABLE_COST",
                        expression: "'TCPA_SHIELD_HISTORY_TABLE_COST'"
                      }
                    ],
                    attrs: { "sort-key": "cost" }
                  },
                  [_vm._v("\n          Cost\n        ")]
                )
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "pagination-min" }, [
        _c(
          "div",
          { staticClass: "text-center p-7" },
          [
            _c("smart-pagination", {
              attrs: {
                "current-page": _vm.currentPage,
                "total-pages": _vm.totalPages,
                "max-page-links": 10
              },
              on: {
                "update:currentPage": function($event) {
                  _vm.currentPage = $event
                },
                "update:current-page": function($event) {
                  _vm.currentPage = $event
                }
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.loadingStatus === "pending"
        ? _c(
            "div",
            { staticClass: "well well-sm text-center" },
            [
              _c("Loader"),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "TCPA_SHIELD_HISTORY_TABLE_LOADING",
                    expression: "'TCPA_SHIELD_HISTORY_TABLE_LOADING'"
                  }
                ]
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loadingStatus === "success" && _vm.tcpaHistoryData.length === 0
        ? _c("div", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "TCPA_SHIELD_HISTORY_TABLE_EMPTY",
                expression: "'TCPA_SHIELD_HISTORY_TABLE_EMPTY'"
              }
            ],
            staticClass: "well well-sm text-center"
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }